import { t as tr } from './i18n';
import { fmtNum } from './format';
import type { Offer, RfqItem } from './types';

/**
 * Cât a ofertat furnizorul față de cât s-a cerut. Ceri 1.000 mp, primești o
 * ofertă pentru 500: nu e greșită (poate atât are), dar nu e același lucru și
 * nu are voie să câștige comparația doar pentru că e pe jumătate de cantitate.
 */

/** Sub atâta din cantitatea cerută, oferta pe poziție e parțială. La cofraje nu iese fix suprafața. */
export const PARTIAL_BELOW = 0.98;

/** Cantitatea ofertată pe poziție, în unitatea ei; null = oferta n-o spune (deci e cea cerută). */
export function offeredQty(offer: Offer, item: RfqItem): number | null {
  const pkg = offer.packages?.[item.id];
  if (pkg) return pkg.coveredQty;
  return offer.offered?.[item.id] ?? null;
}

export interface Shortfall {
  requested: number;
  offered: number;
  /** negativ: cât lipsește */
  diff: number;
}

/** Poziția e ofertată pe mai puțin decât s-a cerut; null dacă e completă sau necotată. */
export function shortfall(offer: Offer, item: RfqItem): Shortfall | null {
  if (offer.prices[item.id] == null) return null;
  const q = offeredQty(offer, item);
  if (q == null || q >= item.qty * PARTIAL_BELOW) return null;
  return { requested: item.qty, offered: q, diff: q - item.qty };
}

/** „ofertat 500 din 1.000 mp (−500 mp)” */
export function shortfallText(s: Shortfall, unit: string): string {
  return tr(
    'ofertat {0} din {1} {2} (−{3} {4})',
    fmtNum(s.offered),
    fmtNum(s.requested),
    unit,
    fmtNum(-s.diff),
    unit,
  );
}

/** Măcar o poziție e ofertată pe mai puțin decât s-a cerut. */
export const isPartial = (offer: Offer, items: RfqItem[]): boolean =>
  items.some((it) => shortfall(offer, it) != null);
